import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import './inAppOrderList.scss'
import moment from "moment";

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';

//import images
import {reactLocalStorage as Storage} from "reactjs-localstorage";
import {
  Badge,
  Button, ButtonGroup,
  FormCheckbox,
  FormInput,
  FormSelect,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import {toast} from "react-toastify";
import ModalLoading from "../../../components/common/ModalLoading";



let model = {
  store: {
    name: '',
    domain: '',
    logo: '',
    platform: '',
    platformId: '',
    addrMain: '',
    addrSub: '',
    presidentName: '',
    tel: '',
    email: '',
    notificationEmail: '',
    customerService: {},
    privacyOfficer: {},
    pTeamUser_id: ''
  }
}

// model.store = {
//   name: '온노마드',
//   domain: 'http://onnomad.co.kr/',
//   logo: '',
//   platform: 'nhn_godo',
//   platformId: '',
//   addrMain: '서울시 성동구 상원1길 25 ',
//   addrSub: '4160호 (주)온노마드',
//   presidentName: '윤정진',
//   tel: '02-6417-7000',
//   email: '',
//   notificationEmail: 'godrium@naver.com',
//   customerService: {},
//   privacyOfficer: {},
//   pTeamUser_id: ''
// }

@inject(({ common }) => ({ setIsShowPopup: common.setIsShowPopup, isShowModal: common.isShowModal, getIsShowPopup: common.getIsShowPopup  }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, getInAppOrderList: teamUser.getInAppOrderList }))
@inject(({ AOA }) => ({ getStoreOrderList:AOA.getStoreOrderList, getStoreList:AOA.getStoreList, getStoreDetail:AOA.getStoreDetail, updateStoreMemo:AOA.updateStoreMemo, csLogin:AOA.csLogin, renewToken:AOA.renewToken, unsubscribeUser: AOA.unsubscribeUser, withdrawal: AOA.withdrawal }))
@inject(({ company }) => ({ updateStore:company.updateStore  }))

@observer
class StoreOrderList extends Component {

  //basic
  @observable store = {};

  @observable teamUser = {};
  @observable permissions = {}
  // @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  @observable searchFormValue = {
    isPaidUser: true,
    isUseFirstOrder: false,
    isFreeStore: false
  }

  @observable listParams = {page:1, limit:100, searchParams: {}};
  @observable list = {};
  @observable isPopupOpen = false;

  //modals
  @observable modals = {
    isStoreDetail: false,
    storeDetailData: {},
  };

  @observable storageCfg = {
    is: true,
    etcType: "fn"
  };

  constructor(props) {
    super(props);
    this.init()

    // this.onChangeValue = this.onChangeValue.bind(this);
    // this.onSubmit = this.onSubmit.bind(this);
    // this.delTeamUser = this.delTeamUser.bind(this);
    // this.updateStore = this.updateStore.bind(this);
    // this.openPostCode = this.openPostCode.bind(this);
    // this.closePostCode = this.closePostCode.bind(this);
    // this.setAddress = this.setAddress.bind(this);
    // this.getTeamUserList = this.getTeamUserList.bind(this);
  }


  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : model.store;
      this.listParams.store_id = this.store._id;

      let storageCfg = await Storage.getObject('storageCfg');
      if(storageCfg.is) {
        this.storageCfg = storageCfg;
      }

      this.permissions = this.props.me.permissions;
      if(this.teamUser.isSuper && this.listParams.store_id) {
        this.urlParamsToListParams();
      }
    }
    else {

      if(Storage.get('token')) {
        //todo 재확인 - 로그인 후 해당 페이지로 넘어 오는 경우 authCheck() 함수 미샐행 할 수 있게.
        //this.props.authCheck();
      }
      // else {
      //   window.location.replace('signIn');
      // }

    }
  };



  urlParamsToListParams = function() {

    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {

      if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if(key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if(!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {};}
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          if(this.urlParams.get(key) === "true") {
            this.searchFormValue[key] = true;
            this.listParams.searchParams[key] = true;
          }
          else if(this.urlParams.get(key) === "false") {
            this.searchFormValue[key] =  false;
            this.listParams.searchParams[key] = false;
          }
          else {
            this.searchFormValue[key] = this.urlParams.get(key);
            this.listParams.searchParams[key] = this.urlParams.get(key);
          }

        }
      }
    }

    for(let key in searchFormValueArr) {
      if(searchFormValueArr[key].all) {
        for(let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for(let deKey in this.searchFormValue[key]) {
          if(searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }
    this.getList();
  }

  @action
  getList =async() => {
    this.listParams.isSuper = true;
    this.list = await this.props.getStoreOrderList(this.listParams);
    this.isLoading = false;
    console.log(this.list)
  };

  csLogin = async (item) => {
    let params = {
      id: item.store_id._id,
      platformId: item.store_id.platformId,
      emailId: item.store_id.email
    }
    console.log(params)
    await this.props.csLogin(params);
    await Storage.remove("shops");
    window.location.href = "/reviewList";
  };

  modalToggle = function(target, data) {
    let _this = this;
    if(!target) {
      for( var i in _this.modals) {
        if(i.indexOf('is') === 0) {
          _this.modals[i] = false;
        }
      }
    }
    else {
      _this.modals[target] = !this.modals[target];
    }

    if(data) {
      if(target === 'isStoreDetail' && data) {
        _this.modals.storeDetailData = data;

        let params = {
          store_id: data.store_id._id,
          order_id: data.platformOrderId,
          isRefreshToken: true
        }
        this.props.getStoreDetail(params, function(res) {
          if(res.errors && res.errors.length > 0) {
            toast(res.errors[0].message);
          }
          else {
            _this.modals.storeDetailData.detail = res.data;
            _this.modals.shop= res.data.shop;
          }
        });

      }
      else {
        _this.modals.data = data;
      }

    }
  };

  onChangeSearchValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.searchFormValue[name] = newValue;
      if(name === 'isDelete') {
        for(let key in this.searchFormValue.reviewDis) {
          this.searchFormValue.reviewDis[key] = !newValue;
        }
      }
    }

    if(name === "sort") {
      this.listParams.sort = newValue;
      this.getList();
    }
  };

  onChangeStorageCfg = async (targetObj, val, key) => {
    console.log(targetObj)
    if(key) {
      targetObj[key] = val;
    }
    else {
      targetObj = val;
    }
    Storage.setObject('storageCfg', this.storageCfg);
  };

  updateStoreMemo = async (item) => {
    let params = {
      id: item._id,
      memo: item.memo
    }
    let res = await this.props.updateStoreMemo(params);
    console.log(res);
  };

  onChangeMemoValue = async (event, item) => {
    const { name, value } = event.target;
    item[name] = value;
  };


  onChangeModalInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    console.log(name, value, targetObj)
    targetObj[name] = value;
  };
  delAllReview = async function(item) {
    if(window.confirm('모든 리뷰를 삭체 처리 하시겠습니까?')) {
      let withDrawStore = {
        store_id: item.id,
        // startDate: moment().subtract(3, 'years'),
        // endDate: moment().subtract(1, 'months')
      };
      await this.props.removeReviewMany(withDrawStore);
    }
  };

  withdrawal = async (item) => {
    if(window.confirm('탈퇴처리 하시겠습니까?')) {
      let withDrawStore = {
        store_id: item._id,
        reason: "탈퇴처리"
      };
      await this.props.withdrawal(withDrawStore);
    }

  };

  unsubscribeUser = async (item) => {
    if(!item.shopNo) {
      alert("구독취소할 멀티샵을 선택해 주세요.");
      return false;
    }
    if(window.confirm('구독취소 하시겠습니까?')) {
      let unsubscribeUser = {
        store_id: item._id,
        shopNo: parseInt(item.shopNo)
      };
      await this.props.unsubscribeUser(unsubscribeUser);
    }

  };

  render() {
    let _this = this;
    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
                { startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page="+(startNum-1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
                {rendering()}
                { endNum !== totalPages  ? <li className="btn-page-next"><a href={urlParams + "&page="+(startNum+10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
                { curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + "&page="+totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }

    }

    // (구) PaySuccess 함수 — 호출처 없음. 필요 시 storeOrderList 의 결제상태 라벨 컴포넌트 재도입 위치.

    function GetOrderType(props) {
      let statusDom = '';
      //승인상태 (REG: 등록, REQ: 심사요청, APR: 승인, REJ: 반려)
      switch (props.orderType){
        case "free" :
          statusDom = <Badge theme="info">무료</Badge>;
          break;
        case "autoPayment" :
          statusDom = <Badge theme="danger">구독</Badge>;
          break;
        case "regular" :
          statusDom = <Badge theme="danger">구독</Badge>;
          break;
        case "event" :
          statusDom = <Badge>선결제</Badge>;
          break;
        case "event_4p2_first" :
          statusDom = <Badge>선결제</Badge>;
          break;
        case "event_6p6_first" :
          statusDom = <Badge>선결제</Badge>;
          break;
        case "반려" :
          statusDom = <Badge outline theme="info">반려</Badge>;
          break;
        default :
          statusDom = <Badge outline theme="info">{props.orderType}</Badge>;
          break;
      }
      return statusDom;
    }

    function PaymentItem(props) {
      let statusDom;
      //승인상태 (REG: 등록, REQ: 심사요청, APR: 승인, REJ: 반려)
      let item = props.paymentItem;
      let paymentStatus;
      switch (item.payment_status){
        case "paid" :
          paymentStatus = <Badge theme="info">결제완료</Badge>;
          break;
        default :
          paymentStatus = <Badge theme="info">{props.payment_status}</Badge>;
          break;
      }
      let automatic;
      switch (item.automatic_payment){
        case "T" :
          automatic = <Badge theme="info">구독</Badge>;
          break;
        default :
          automatic = <Badge theme="info">선결제</Badge>;
          break;
      }
      let method;
      switch (item.payment_method) {
        case "CARD" :
          method = <Badge theme="info">카드</Badge>;
          break;
        case "vcash" :
          method = <Badge theme="info">입금</Badge>;
          break;
        default :
          method = <Badge theme="info">{item.payment_method}</Badge>;
          break;
      }

      statusDom = <p>{(paymentStatus)} {automatic} {method} 결제일: {moment(item.pay_date).format('YYYY.MM.DD')}, 금액: {new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(item.payment_amount)}</p>
      return statusDom;
    }

    function GetThisMonthPayDday(props) {
      let targetDate = props.targetDate;
      let payType = props.payType;
      if(!targetDate) {
        return "?"
      }
      if(payType === "autoPayment" || payType === "regular") {
        let dDay = moment(targetDate).date() - moment().date();
        if(dDay < 5 && dDay > -5) {
          dDay = (
              <strong className={"text-danger"}>{dDay + getMonthDifference(targetDate)}</strong>
          )
        }
        else {
          dDay = getMonthDifference(targetDate);
        }
        return dDay;
      }
      else {
        let dDay = moment(targetDate).diff(moment(), 'days');
        if(dDay < 30 && dDay > -7) {
          dDay = (
              <strong className={"text-danger"}>~{moment(targetDate).format("YYYY.MM.DD") + "(" + dDay + ")"}</strong>
          )
        }
        else {
          dDay = (
              <span>~{moment(targetDate).format("YYYY.MM.DD") + "(" + dDay + ")"}</span>
          )
        }
        return dDay;
      }

    }

    function getMonthDifference(targetDate) {
      const today = moment().startOf('day'); // 오늘 날짜 (시간 제거)
      const target = moment(targetDate).startOf('day'); // 특정 날짜 (시간 제거)
      const diff = today.diff(target, 'months')+1; // 월 차이 계산

      return "(" + Math.max(0, diff) + ")"; // 음수 방지
    }

    return (
        <div className="main-content">
          <PageTitle />
          {/*<Row  className="mtb-10">*/}
          {/*  <Col xs={12}><Button onClick={event => this.adminCusData()}>커스텀</Button></Col>*/}
          {/*</Row>*/}
          <div className="user-list-box">
            <div className="section-box">
              <form id="" target="" className="">
                <div className="user-search-box">
                  <table>
                    <tbody>
                    <tr>
                      <th>검색어</th>
                      <td>
                        <div className="search-input-box">
                          {/*<select name="searchType" className="search-type">*/}
                          {/*  <option value="">이름</option>*/}
                          {/*  <option value="">주문번호</option>*/}
                          {/*</select>*/}
                          <input type="text" name="keyword" className="table-input-text search-input"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>주문한 스토어</th>
                      <td>
                        <label className=""><input type="checkbox" name="automaticPayment" onChange={event => {
                          this.onChangeSearchValue(event)
                        }} value={this.searchFormValue.automaticPayment}
                                                       checked={Boolean(this.searchFormValue.automaticPayment)}/><span>구독</span></label>

                        <label className="ml-5"><input type="checkbox" name="onepay" onChange={event => {
                          this.onChangeSearchValue(event)
                        }} value={this.searchFormValue.onepay}
                                                   checked={Boolean(this.searchFormValue.onepay)}/><span>선결제</span></label>

                        <label className="ml-5"><input type="checkbox" name="isFreeStore" onChange={event => {
                          this.onChangeSearchValue(event)
                        }} value={this.searchFormValue.isFreeStore}
                                                       checked={Boolean(this.searchFormValue.isFreeStore)}/><span>무료</span></label>

                        <label className="ml-5"><input type="checkbox" name="isAll" onChange={event => {
                          this.onChangeSearchValue(event)
                        }} value={this.searchFormValue.isAll}
                                                       checked={Boolean(this.searchFormValue.isAll)}/><span>전체</span></label>

                        <label className="ml-5"><input type="checkbox" name="isSuspended" onChange={event => {
                          this.onChangeSearchValue(event)
                        }} value={this.searchFormValue.isSuspended}
                                                       checked={Boolean(this.searchFormValue.isSuspended)}/><span>정지</span></label>

                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div className="btn-search">
                    <input type="submit" value="검색" className="search-button"/>
                  </div>
                </div>
              </form>

            </div>
            <div className="section-box">
              <form id="" target="" className="">
                <div className="user-list-table">
                  <div className="user-pick-list">
                    <div className="pick-list-count">
                      검색결과 <span>{this.list.totalDocs}</span>개
                    </div>
                    <div className="choice-num-view">
                      <FormCheckbox
                          inline
                          checked={this.storageCfg.etcType === "fn"}
                          onChange={event => this.onChangeStorageCfg(this.storageCfg, 'fn', 'etcType')}
                      >
                        기능버튼

                      </FormCheckbox>
                      <FormCheckbox
                          inline
                          checked={this.storageCfg.etcType === "input"}
                          onChange={event => this.onChangeStorageCfg(this.storageCfg, 'input', 'etcType')}
                      >
                        비고입력
                      </FormCheckbox>
                      <select name="limit"
                              value={this.listParams.limit}
                              onChange={event => {
                                this.listParams.limit = parseInt(event.target.value);
                                this.onChangeSearchValue(event, this.listParams);
                              }}
                              className="">
                        <option value="50">50개씩 보기</option>
                        <option value="100">100개씩 보기</option>
                        <option value="200">200개씩 보기</option>
                        <option value="20">20개씩 보기</option>
                      </select>
                      <select name="sort"
                              value={this.listParams.sort}
                              onChange={event => {
                                this.listParams.sort = event.target.value;
                                this.onChangeSearchValue(event, this.listParams);
                              }}
                              className="">
                        <option value="createdAt">주문날짜순</option>
                        <option value="endDate">사용완료순</option>
                      </select>
                    </div>
                  </div>
                  <table className="store-list">
                    <colgroup>
                      <col width="13%"/>
                      <col width="7%"/>
                      <col width="7%"/>
                      <col width="15%"/>
                      <col width="7%"/>
                      <col width="7%"/>
                      {this.storageCfg.etcType === "fn" ? (<>
                        <col width="7%"/>
                        <col width="10%"/>
                        <col width="10%"/>
                      </>) : (<></>)}
                      <col width=""/>
                      <col width="5%"/>
                    </colgroup>
                    <thead>
                    <tr>
                      {/*<th>플렛폼 정보</th>*/}
                      <th>스토어</th>
                      <th>스토어 ID</th>
                      <th>샵</th>
                      <th>연락처</th>
                      <th>활*스</th>
                      <th>주문일</th>
                      {this.storageCfg.etcType === "fn" ? (<>
                        <th>타입</th>
                        <th>주문상세</th>
                        <th>사용 기간</th>
                      </>) : (<></>)}
                      <th></th>
                      <th>SC</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.list && this.list.docs && this.list.docs.length > 0 ?
                        this.list.docs.map((item, i) => (
                            <tr key={i}>
                              {item.store_id && item.shop ? (
                                  <td className={item.store_id && item.store_id.isDelApp ? "text-red" : ""}>
                                    {item.shop.primaryDomain ? (
                                        <a className={item.store_id.isDelApp ? "text-red" : ""} href={"https://" + item.shop.primaryDomain} target="_blank" rel="noopener noreferrer">{item.store_id.name}({item.store_id.presidentName})</a>
                                    ) : (
                                        <a className={item.store_id.isDelApp ? "text-red" : ""} href={"https://" + item.shop.baseDomain} target="_blank" rel="noopener noreferrer">{item.store_id.name}({item.store_id.presidentName})</a>
                                    )}</td>
                              ) : (
                                  <td>샵 id : {item._id}</td>
                              )}
                              {item.store_id ? (
                                  <td className={item.store_id.isDelApp ? "text-red" : ""}>
                                    {item.store_id.domain ? (
                                        <a className={item.store_id.isDelApp ? "text-red" : ""} href={"https://" + item.store_id.domain} target="_blank" rel="noopener noreferrer">{item.store_id.platformId}</a>
                                    ) : (
                                        <a className={item.store_id.isDelApp ? "text-red" : ""} href={"https://" + item.store_id.platformId + ".cafe24.com"} target="_blank" rel="noopener noreferrer">{item.store_id.platformId}</a>
                                    )}</td>
                              ) : (
                                  <td></td>
                              )}
                              <td><a className={item.store_id && item.store_id.isDelApp ? "text-red" : ""} href={"https://" + (item.primaryDomain ? item.primaryDomain : item.baseDomain)} target="_blank" rel="noopener noreferrer">{item.shop ? item.shop.shopName : ""} ({item.shop ? item.shop.platformShopNo : ""})</a></td>
                              <td>{item.store_id ? item.store_id.email : ""} / {item.store_id ? item.store_id.tel : ""}</td>
                              <td>{item.vr_skin ? item.vr_skin.length : 0}</td>
                              <td>{moment(item.createdAt).format('YYYY.MM.DD')}</td>
                              {this.storageCfg.etcType === "fn" ? (<>
                                <td className={"text-center"}><GetOrderType orderType={item.payType}></GetOrderType></td>
                                <td>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(item.orderAmount)}</td>
                                <td>{item.payType === "autoPayment" || item.payType === "regular" ? "" : <GetThisMonthPayDday targetDate={item.endDate} payType={item.payType}/>}</td>
                                {/*<td>{moment(item.endDate).diff(moment(), 'days') > 10000 ? "" : ( "~ " + moment(item.endDate).format('YYYY.MM.DD') + " (" + getThisMonthPayDday(moment(item.endDate).diff(moment(), 'days'), "") + ")" )}</td>*/}
                              </>) : (<></>)}
                              <td>
                                {this.storageCfg.etcType === "fn" ? (
                                    <>
                                      <ButtonGroup>
                                        <Button onClick={e => this.csLogin(item)}>login</Button>
                                        <Button onClick={e => this.modalToggle('isStoreDetail', item)}>상세</Button>
                                      </ButtonGroup>
                                    </>
                                ) : (
                                    <InputGroup>
                                      <FormInput name="memo" placeholder="메모" onChange={event => {
                                        this.onChangeMemoValue(event, item.store_id)
                                      }} value={item.store_id.memo} className="table-input-text"/>
                                      <InputGroupAddon type="append"><Button theme="secondary" onClick={e => {
                                        this.updateStoreMemo(item.store_id)
                                      }}><i className="material-icons">업데이트</i></Button><Button onClick={e => this.csLogin(item)}>login</Button><Button onClick={e => this.modalToggle('isStoreDetail', item)}>상세</Button></InputGroupAddon>
                                    </InputGroup>
                                )}
                              </td>
                              <td>{ (item.payType === "autoPayment" || item.payType === "regular") ? <GetThisMonthPayDday targetDate={item.inAppOrderupdatedAt} payType={item.payType}/> : "" }</td>

                            </tr>))
                        :
                        <tr>
                          <td colSpan={9} className="text-center">가입한 스토어가 없습니다</td>
                        </tr>
                    }

                    </tbody>
                  </table>
                  <Pagination />
                </div>
              </form>
            </div>
          </div>
          <Modal size="lg" className='modal-review-write-form' open={this.modals.isStoreDetail} toggle={() => this.modals.isStoreDetail = false} centered={true}>
            <ModalHeader toggle={() => this.modals.isStoreDetail = false}>스토어 상세 보기</ModalHeader>
            <ModalBody className="history-window-popup">
              <div className="history-popup-contents">
                {this.modals.storeDetailData.store_id ? (
                    <table>
                      <colgroup>
                        <col style={{width: '15%'}}/>
                        <col style={{width: '35%'}}/>
                        <col style={{width: '15%'}}/>
                        <col style={{width: '35%'}}/>
                      </colgroup>
                      <tbody>
                      <tr>
                        <th>쇼핑몰</th>
                        <td>{this.modals.storeDetailData.store_id.name}({this.modals.storeDetailData.store_id.presidentName})
                          / {this.modals.storeDetailData.store_id.domain ? (
                              <a href={"https://" + this.modals.storeDetailData.store_id.domain}
                                 target="_blank" rel="noopener noreferrer">{this.modals.storeDetailData.store_id.domain}</a>
                          ) : (
                              <a href={"https://" + this.modals.storeDetailData.store_id.platformId + ".cafe24.com"}
                                 target="_blank" rel="noopener noreferrer">{this.modals.storeDetailData.store_id.platformId + ".cafe24.com"}</a>
                          )} / {this.modals.storeDetailData.store_id.platformId}</td>
                        <th>평균 주문수</th>
                        <td>{this.modals.storeDetailData.detail ? Math.ceil(this.modals.storeDetailData.detail.getMonthlySales / 3) : 0}</td>
                      </tr>
                      <tr>
                        <th>주문수 시작일</th>
                        <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.getMonthlySalesStartDate : ''}</td>
                        <th>주문수 종료일</th>
                        <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.getMonthlySalesEndDate : ''}</td>
                      </tr>
                      <tr>
                        <th>결제내용</th>
                        <td colSpan="3">
                          {this.modals.storeDetailData.detail && this.modals.storeDetailData.detail.orderStatus && this.modals.storeDetailData.detail.orderStatus.length > 0 ?
                              (<ul>
                                {this.modals.storeDetailData.detail.orderStatus.map((item, i) => (
                                 <li key={i}><PaymentItem paymentItem={item}/></li>
                                ))}
                              </ul>)
                              : null}
                        </td>
                      </tr>
                      <tr>
                        <th>리뷰 수</th>
                        <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.reviewCount : 0}
                          <Button className="ml-2" theme="danger"
                                  onClick={event => this.delAllReview(this.modals.storeDetailData)}>전체삭제</Button></td>
                        <th>상품 수</th>
                        <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.productCount : 0}</td>
                      </tr>
                      <tr>
                        <th>회원탈퇴</th>
                        <td><Button className="ml-2" theme="danger"
                                    onClick={event => this.withdrawal(this.modals.storeDetailData)}>회원탈퇴</Button></td>
                        <th>구독취소</th>
                        <td>
                          <FormSelect name="shopNo"
                                      onChange={event => {
                                        this.onChangeModalInputs(event, this.modals.storeDetailData.store_id)
                                      }}>
                            <option value="">-</option>
                            {
                              this.modals && this.modals.shop ? this.modals.shop.map((item, i) => (
                                  <option key={i} value={item.platformShopNo}>{item.platformShopNo}-{item.shopName}</option>
                              )) : null
                            }
                          </FormSelect>
                          <Button className="ml-2" theme="danger"
                                  onClick={event => this.unsubscribeUser(this.modals.storeDetailData.store_id)}>구독취소</Button>
                        </td>
                      </tr>
                      <tr>
                        <th>id</th>
                        <td>{this.modals.storeDetailData.store_id._id}</td>
                        <th>결제 id</th>
                        <td>{this.modals.storeDetailData._id}</td>
                      </tr>
                      <tr>
                        <th>cafe24Tokens</th>
                        <td colSpan={3}>
                          {this.modals.storeDetailData.cafe24Tokens && this.modals.storeDetailData.cafe24Tokens.length > 0 ?
                              (<ul>
                                {
                                  this.modals.storeDetailData.cafe24Tokens.map((item, i) => (
                                      <li key={i}>{moment(item.refresh_token_expires_at).format("MM-DD")} {' // scopes : '} {item.scopes ? item.scopes.length : ""}</li>
                                  ))
                                }
                              </ul>) : null}
                        </td>
                      </tr>
                      </tbody>
                    </table>) : null}

                <div className="text-center mt-2">
                  {/*<Button onClick={event => this.updateReview(this.modals.data)} >리뷰작성</Button>*/}
                  <Button className="ml-2" theme="light" onClick={event => this.modals.isStoreDetail = false}>닫기</Button>
                </div>
              </div>

            </ModalBody>
          </Modal>
          <ModalLoading isLoading={this.isLoading}/>
        </div>
    )
  }
}

export default StoreOrderList;
